import { render, staticRenderFns } from "./keywordDataCollect.vue?vue&type=template&id=0c0d07ea&scoped=true"
import script from "./keywordDataCollect.vue?vue&type=script&lang=js"
export * from "./keywordDataCollect.vue?vue&type=script&lang=js"
import style0 from "./keywordDataCollect.vue?vue&type=style&index=0&id=0c0d07ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d07ea",
  null
  
)

export default component.exports